import { Settings, Video, MessageCircle, Reply, TrendingUp } from 'lucide-react';
import { useTiktokStats } from '@/api/useTiktok';
import { useTiktokStore } from '@/stores/useTiktokStore';
import { TiktokVideoList } from '@/components/tiktok/TiktokVideoList';
import { TiktokCommentFeed } from '@/components/tiktok/TiktokCommentFeed';
import { TiktokAgentConfigPanel } from '@/components/tiktok/TiktokAgentConfigPanel';
import styles from './TiktokComments.module.css';

export function TiktokComments() {
  const { selectedVideoId, toggleAgentConfig } = useTiktokStore();
  const { data: stats } = useTiktokStats();

  return (
    <div className={styles.container}>
      {/* Top bar */}
      <div className={styles.topBar}>
        <div className={styles.topLeft}>
          <div className={styles.titleGroup}>
            <div className={styles.tiktokDot} />
            <h1 className={styles.title}>TikTok Comments</h1>
          </div>
        </div>

        {stats && (
          <div className={styles.statsPills}>
            <div className={styles.pill}>
              <Video className={styles.pillIcon} />
              <span className={styles.pillValue}>{stats.monitoredVideos}</span>
              <span className={styles.pillLabel}>monitored</span>
            </div>
            <div className={styles.pill}>
              <MessageCircle className={styles.pillIcon} />
              <span className={styles.pillValue}>{stats.totalComments}</span>
              <span className={styles.pillLabel}>comments</span>
            </div>
            <div className={styles.pill}>
              <Reply className={styles.pillIcon} />
              <span className={styles.pillValue}>{stats.autoReplied}</span>
              <span className={styles.pillLabel}>auto-replied</span>
            </div>
            <div className={styles.pill}>
              <TrendingUp className={styles.pillIcon} />
              <span className={styles.pillValue}>{(stats.replyRate ?? 0).toFixed(0)}%</span>
              <span className={styles.pillLabel}>reply rate</span>
            </div>
          </div>
        )}

        <button onClick={toggleAgentConfig} className={styles.gearBtn} title="Agent Configuration">
          <Settings className={styles.gearIcon} />
        </button>
      </div>

      {/* Split layout */}
      <div className={styles.layout}>
        <div className={`${styles.videosPanel} ${selectedVideoId ? styles.hideOnMobile : ''}`}>
          <TiktokVideoList />
        </div>
        <div className={`${styles.commentsPanel} ${!selectedVideoId ? styles.hideOnMobile : ''}`}>
          <TiktokCommentFeed videoId={selectedVideoId} />
        </div>
      </div>

      <TiktokAgentConfigPanel />
    </div>
  );
}
